import React from 'react'
import {Attributes, Label} from "../../modules/tp/builders/FormBuilder";
import {FormikProps} from "formik";
import { Entity } from 'app/models/entity';

export type MultiTextViewProps<T extends Entity> = {
    formik: FormikProps<T>,
    inputObj: MultiTextViewObj<T>
    entity: T,
}

export type MultiTextViewObj<T> = {
    [key: string]: any,
    type: "multiTextView",
    key: keyof T,
    attributes?: Attributes,
    stringifyFunction: (entity: any) => string
} & Attributes & Label

const MultiTextView = <T extends Entity,>(props: MultiTextViewProps<T>) =>
{
    const entities = (props.entity[props.inputObj.key] || []) as Array<T>;

    return (<>
        {props.inputObj.label && <label>{props.inputObj.label}</label>}
        {entities?.map((entity: T) =>
            <input
                {...props}
                key={entity.id}
                type='text'
                autoComplete='off'
                readOnly={true}
                disabled={true}
                value={props.inputObj.stringifyFunction(entity)}
            />
        )}
    </>
    )
};

export default MultiTextView;
